import type {
  TrackingContext,
  TrackingPlacement,
} from '@mentimeter/http-clients';
import {
  UpgradeType,
  type TrackingProperties,
  type UpgradeEvent,
} from '../../types';
import { useClosePopoverPaywall } from '../hooks/use-popover-paywall';
import { useTrackOpenPaywall } from '../tracking/track-open-paywall';
import { useTrackClickUpgrade } from '../tracking/track-click-upgrade';
import { SelfUpgradePopoverContentGeneric } from './popover/SelfUpgradePopoverContentGeneric';

interface SelfUpgradePopoverGenericProps {
  title: string;
  description: string;
  badge?: 'basic' | 'pro' | undefined;
  width?: string;
  isEducationalUser: boolean;
  upgradeEvent: UpgradeEvent;
  upgradeEventContext: string;
  trackingContext: TrackingContext | undefined;
  trackingPlacement: TrackingPlacement;
  trackingProperties?: TrackingProperties;
}

export function SelfUpgradePopoverGeneric({
  title,
  description,
  badge,
  width = '300px',
  upgradeEvent,
  upgradeEventContext,
  trackingProperties,
  trackingContext,
  trackingPlacement,
  isEducationalUser,
}: SelfUpgradePopoverGenericProps) {
  const closePopover = useClosePopoverPaywall();
  const trackClickUpgrade = useTrackClickUpgrade({
    upgradeEvent,
    upgradeEventContext,
    trackingProperties,
  });

  useTrackOpenPaywall({
    trackingContext,
    trackingPlacement,
    upgradeType: UpgradeType.SELF_UPGRADE,
  });

  return (
    <SelfUpgradePopoverContentGeneric
      title={title}
      description={description}
      badge={badge}
      width={width}
      isEducational={isEducationalUser}
      trackClickUpgrade={trackClickUpgrade}
      onDismissClick={closePopover}
    />
  );
}
